import { Link } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';

import { useGetParentsBulkImportStatus } from '~entities/parent/api/get-parents-bulk-import-status';

import { BulkImportResultsPanel } from '~pages/parents/bulk-upload/bulk-import-results-panel';

interface BulkUploadImportResultsPageProps {
  jobId: string;
}

export function BulkUploadImportResultsPage({
  jobId,
}: BulkUploadImportResultsPageProps) {
  const { data, isLoading, isError } = useGetParentsBulkImportStatus({ jobId });
  const job = data?.job;

  return (
    <div className='flex min-h-screen flex-col p-4'>
      <div className='mb-6 flex flex-wrap items-center justify-between gap-4'>
        <Link
          className='flex w-fit items-center gap-2'
          to='/parents/bulk-upload/history'
        >
          <CircleArrowLeft className='size-6' />
          <span className='text-lg font-semibold'>Import history</span>
        </Link>
        <Link
          to='/parents/bulk-upload'
          className='text-sm text-primary underline'
        >
          New bulk upload
        </Link>
      </div>

      {isLoading ? (
        <div className='flex items-center gap-2 text-muted-foreground'>
          <Loader2 className='size-5 animate-spin' />
          Loading import results…
        </div>
      ) : isError || !job ? (
        <p className='text-sm text-destructive'>
          Could not load import results. The job may have expired.
        </p>
      ) : (
        <BulkImportResultsPanel job={job} />
      )}
    </div>
  );
}
